//计算流体力学
import { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';
// import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { RootObject, CooperationCaseTabsList, SideImgList, PartnersList } from '../../type';
import './style.less';


const FluidMechanics = (props: RootObject['fluidMechanics']) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    // 获取合作伙伴图片数量
    // const [partnersImgList, setPartnersImgList] = useState<number>(props?.CooperationCaseTabsList[0]?.CooperationCaseTabsContent[0]?.partners.partnersList.length - 5);
    // const [partnersImgList, setPartnersImgList] = useState<number>(10);
    // const [count, setCount] = useState<number>(0);

    const tabRef = useRef<HTMLDivElement>(null);
    const fluidUlRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    // 左箭头
    // const leftArrow = () => {
    //     // if (count === 0) {
    //     //     return;
    //     // } else {
    //     //     setCount(count + 1);
    //     // }
    //     setCount(count + 1);
    // };
    // 右箭头
    // const rightArrow = () => {
    //     setCount(count - 1);
    // };
    useEffect(() => {
        if (tabRef.current && contentRef.current) {
            console.log('tabRef.current:', tabRef.current);
            tabRef.current.style.left = `${132 * currentIndex}px`;
            contentRef.current.style.left = `-${1200 * currentIndex}px`;
        }
    }, [currentIndex]);

    // useEffect(() => {
    //     if (fluidUlRef.current) {
    //         // fluidUlRef.current.style.left = 227 * count + "px";
    //         fluidUlRef.current.style.left = `${ count * 227}px`;
    //         console.log(fluidUlRef);
    //         console.log('fluidUlRef.current:', fluidUlRef.current);
           
    //     }
    //     // const urDom = document.querySelector('.bottom_img_ul') as HTMLDivElement;
    //     // if (urDom) {
    //     //     urDom.style.left = `-${227 * count}px`;
    //     // }
    // }, [count]);

    return (
        <div className="fluid_mechanics">
            {console.log("我执行了")
            }
            <div className="fluid_mechanics_title">典型合作案例</div>
            <div className="fluid_mechanics_sub_title">- 计算流体力学 -</div>
            {/* table */}
            <div className="fluid_mechanics_content">
                <div className="fluid_mechanics_back_img" style={{ background: `url(${props.backImg})` }}></div>
                {/* tablet头部 */}
                <div className="fluid_mechanics-tab">
                    {props.CooperationCaseTabsList.map((item: CooperationCaseTabsList, index: number) => (
                        <div
                            className={classNames('fluid_mechanics-tab-item', {})}
                            key={index}
                            onClick={() => {
                                setCurrentIndex(index);
                                // setPartnersImgList(item.CooperationCaseTabsContent[0].partners.partnersList.length);
                            }}
                        >
                            <div
                                className={classNames('fluid_mechanics-tab-item-title', {
                                    'current-tab-item': index === currentIndex
                                })}
                            >
                                {item.title}
                            </div>
                        </div>
                    ))}
                </div>
                {/* 滚动条 */}
                <div className="fluid_mechanics-vertical-scroll">
                    <div className="current-selected-tab" ref={tabRef} />
                </div>
                {/* 内容 */}
                <div className="fluid_mechanics-content-wrapper">
                    <div className="fluid_mechanics-content" ref={contentRef}>
                        {props.CooperationCaseTabsList.map((item: CooperationCaseTabsList, index: number) => (
                            <div className="fluid_mechanics-content-item" key={index}>
                                {/* 头部 */}
                                <div className="item_header">
                                    {/* 左边文案信息 */}
                                    <div className="item_header_info">
                                        <div className="header_info_title">
                                            {item.CooperationCaseTabsContent[0].title ?? ''}
                                        </div>
                                        <div className="header_info_content">
                                            {item.CooperationCaseTabsContent[0].headerContent ?? ''}
                                        </div>
                                        {
                                            item.CooperationCaseTabsContent[0].detailLink === "" ?
                                            <Button   className="header_info_content_btn_disbaled" type='primary'
                                            disabled={item.CooperationCaseTabsContent[0].detailLink === "" ? true : false}
                                            >
                                            <a
                                              
                                                href={item.CooperationCaseTabsContent[0].detailLink}
                                            >
                                                {' '}
                                                {item.CooperationCaseTabsContent[0].jumpTitle ?? ''}
                                            </a>
                                            </Button>
                                            :
                                            <Button   className="header_info_content_btn" type='primary'
                                            >
                                            <a
                                              
                                                href={item.CooperationCaseTabsContent[0].detailLink}
                                            >
                                                {' '}
                                                {item.CooperationCaseTabsContent[0].jumpTitle ?? ''}
                                            </a>
                                            </Button>

                                        }
                                      
                                    </div>
                                    {/* 侧右边Img */}
                                    <div className="item_header_side">
                                        {/* 判断图片为多张 */}

                                        {item.CooperationCaseTabsContent[0].sideImgList.length > 1 ? (
                                            <div className="side_img_list">
                                                {item.CooperationCaseTabsContent[0].sideImgList.map(
                                                    (value: SideImgList, index: number) => {
                                                        return <img src={value.partnerList} alt="" key={index} />;
                                                    }
                                                )}
                                            </div>
                                        ) : (
                                            <div className="side_img">
                                                <img
                                                    src={item.CooperationCaseTabsContent[0].sideImgList[0].partnerList}
                                                    alt=""
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* 底部 */}
                                <div className="fluid_item_bottom">
                                    <div className="fluid_bottom_title">
                                        {item.CooperationCaseTabsContent[0].partners.detailLink ?? ''}
                                    </div>
                                    <div className="fluid_bottom_box">
                                        {/* 左箭头 */}
                                        {/* <div className="fluid_left_arrow" onClick={() => leftArrow()}>
                                            <LeftOutlined size={20} color="#ecedef" />
                                        </div> */}
                                        {/* 右箭头 */}
                                        {/* <div className="fluid_right_arrow" onClick={() => rightArrow()}>
                                            <RightOutlined size={20} color="#ecedef" />
                                        </div> */}
                                        <div className="fluid_bottom_img_wrapper" >
                                            {/* <div className="img_wrapper"> */}
                                            <div  ref={fluidUlRef ? fluidUlRef : undefined} className="fluid_bottom_img_ul">
                                                {item.CooperationCaseTabsContent[0].partners.partnersList.map(
                                                    (imgValue: PartnersList, index: number) => {
                                                        return (
                                                            <img
                                                                src={imgValue.partnerList}
                                                                className="fluid_bottom_img_li"
                                                                key={index}
                                                                alt={imgValue.partnerList}
                                                            ></img>
                                                        );
                                                    }
                                                )}
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FluidMechanics;
